import { render, staticRenderFns } from "./DiscussionCard.vue?vue&type=template&id=0376c144&scoped=true"
import script from "./DiscussionCard.vue?vue&type=script&lang=js"
export * from "./DiscussionCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0376c144",
  null
  
)

export default component.exports